import React from 'react'

export const SavePageIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 2H7.99999C7.20434 2 6.44128 2.31607 5.87867 2.87868C5.31606 3.44129 4.99999 4.20435 4.99999 5V21C4.99929 21.1762 5.04517 21.3495 5.13297 21.5023C5.22077 21.655 5.34739 21.7819 5.49999 21.87C5.65201 21.9578 5.82446 22.004 5.99999 22.004C6.17553 22.004 6.34797 21.9578 6.49999 21.87L12 18.69L17.5 21.87C17.6524 21.9564 17.8248 22.0012 18 22C18.1752 22.0012 18.3476 21.9564 18.5 21.87C18.6526 21.7819 18.7792 21.655 18.867 21.5023C18.9548 21.3495 19.0007 21.1762 19 21V5C19 4.20435 18.6839 3.44129 18.1213 2.87868C17.5587 2.31607 16.7956 2 16 2ZM17 19.27L12.5 16.67C12.348 16.5822 12.1755 16.536 12 16.536C11.8245 16.536 11.652 16.5822 11.5 16.67L6.99999 19.27V5C6.99999 4.73478 7.10535 4.48043 7.29289 4.29289C7.48042 4.10536 7.73478 4 7.99999 4H16C16.2652 4 16.5196 4.10536 16.7071 4.29289C16.8946 4.48043 17 4.73478 17 5V19.27Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
